import { uiStore } from "@/store/store-accessor";
import { AccordionState } from "@/types/ui";
import defensiveCopy from "@/util/defensive-copy";

export function getElementAccordionState(
  elementId: number,
  accordionPath: string
): AccordionState {
  return uiStore.panelState.accordionState.elementProperties[elementId]?.[
    accordionPath
  ];
}

export function setElementAccordionState(
  elementId: number,
  accordionPath: string,
  expand: boolean
) {
  const newPanelState = defensiveCopy(uiStore.panelState);

  newPanelState.accordionState.elementProperties = {
    ...newPanelState.accordionState.elementProperties,
    [elementId]: {
      ...newPanelState.accordionState.elementProperties[elementId],
      [accordionPath]: expand
    }
  };

  uiStore.setPanelState(newPanelState);
}

// Selectors

export function getSelectorAccordionState(
  selectorName: string,
  accordionPath: string
): AccordionState {
  return uiStore.panelState.accordionState.selectors[selectorName]?.[
    accordionPath
  ];
}

export function setSelectorAccordionState(
  selectorName: string,
  accordionPath: string,
  expand: boolean
) {
  const newPanelState = defensiveCopy(uiStore.panelState);

  newPanelState.accordionState.selectors = {
    ...newPanelState.accordionState.selectors,
    [selectorName]: {
      ...newPanelState.accordionState.selectors[selectorName],
      [accordionPath]: expand
    }
  };

  uiStore.setPanelState(newPanelState);
}

// Presets

export function getPresetAccordionState(
  presetName: string,
  accordionPath: string
): AccordionState {
  return uiStore.panelState.accordionState.presets[presetName]?.[accordionPath];
}

export function setPresetAccordionState(
  presetName: string,
  accordionPath: string,
  expand: boolean
) {
  const newPanelState = defensiveCopy(uiStore.panelState);

  newPanelState.accordionState.presets = {
    ...newPanelState.accordionState.presets,
    [presetName]: {
      ...newPanelState.accordionState.presets[presetName],
      [accordionPath]: expand
    }
  };

  uiStore.setPanelState(newPanelState);
}

// Global Settings

export function setGlobalSettingsAccordionState(
  accordionPath: string,
  expand: boolean
) {
  const newPanelState = defensiveCopy(uiStore.panelState);

  newPanelState.accordionState.globalSettings = {
    ...newPanelState.accordionState.globalSettings,
    [accordionPath]: expand
  };

  uiStore.setPanelState(newPanelState);
}

export function getGlobalSettingsAccordionState(
  accordionPath: string
): AccordionState {
  return uiStore.panelState?.accordionState?.globalSettings[accordionPath];
}

export function setDynamicDataFieldAttributesAccordionState(
  accordionPath: string,
  expand: boolean
) {
  const newPanelState = defensiveCopy(uiStore.panelState);

  newPanelState.accordionState.dynamicDataFieldAttributes = {
    ...newPanelState.accordionState.dynamicDataFieldAttributes,
    [accordionPath]: expand
  };

  uiStore.setPanelState(newPanelState);
}

export function getDynamicDataFieldAttributesAccordionState(
  accordionPath: string
): AccordionState {
  return uiStore.panelState?.accordionState?.dynamicDataFieldAttributes[
    accordionPath
  ];
}
